import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import CTADetailsAccordion from '../../../components/DetailsAccordion/CTADetailsAccordion';
import CTAChart from './CTAChart';
import WipAvgAge from './WipAvgAge';
import DailyWIP from './DailyWIP';

import { constant } from 'async';

class WallboardCTAChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedPoint: {},
      data: {
        series: [],
        categories: [],
        healthZones: []
      }
    };
  }

  componentDidMount() {
    if (this.props.data) {
      this.setDataPoint();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setDataPoint();
    }
  }

  setDataPoint(day = -1) {
    const data = this.props.data[0];

    if (data) {
      this.setState({
        selectedPoint: {},
        data
      });
    }
  }

  handlePointClick = point => {
    this.setState({
      selectedPoint: point
    });
  };

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Aging Chart</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options
              chart="cta"
              showAvgChart
              showLineChart
              options={{
                avgChartTooltip: 'WIP Average Age',
                lineChartTooltip: 'WIP'
              }}
            />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {this.state.data && !!this.props.data.length && this.props.lineChart && (
            <DailyWIP day={this.props.dates.daysFromStart} data={this.props.data} dateFormat={this.props.dateFormat} />
          )}
          {this.state.data && !!this.props.data.length && this.props.avgChart && (
            <WipAvgAge day={this.props.dates.daysFromStart} data={this.props.data} />
          )}
          <CTADetailsAccordion id="details-accordion" data={this.state.selectedPoint} />
        </div>
        <div className="diagram_details">
          <CTAChart id="CTA" data={this.state.data} onPointClick={this.handlePointClick} />
          <NoData show={this.state.data.series && !this.state.data.series.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    dates: state.filters.dates,
    avgChart: state.filters.cta.avgChart,
    lineChart: state.filters.cta.lineChart,
    data: state.cta.data,
    isLoading: state.cta.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardCTAChart);
